export interface RegisterForFreePageProps {
  showCustomerRegistration?: boolean;
}

export const RegisterForFreePage = ({ showCustomerRegistration }: RegisterForFreePageProps) => {
  return null;
};
